import * as fs from 'node:fs';
import * as path from 'node:path';

/** For a linked worktree, resolve the main repository root from its `.git` file. */
export function resolveMainRepoFromWorktreeGitFile(wt: string): string {
  const gitDirFile = path.join(wt, '.git');
  if (!fs.existsSync(gitDirFile) || !fs.statSync(gitDirFile).isFile()) return '';
  const first = fs.readFileSync(gitDirFile, 'utf8').trim();
  const m = first.match(/^gitdir:\s*(.+)$/im);
  if (!m) return '';
  const gitWorktreePath = path.resolve(wt, m[1].trim());
  const gitDir = path.dirname(path.dirname(gitWorktreePath));
  return path.dirname(gitDir);
}
